<template>
  <span
    v-if="workspaceUsage"
    ref="anchor"
    class="saas-all-workspaces-row-usage"
    :class="{ 'saas-all-workspaces-row-usage--over-limit': overLimit }"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    {{ $t('allWorkspacesWorkspaceRowUsage.rowUsage') }}
    <strong class="saas-all-workspaces-row-usage__count">{{
      workspaceUsage.row_count
    }}</strong>
    <small class="saas-all-workspaces-row-usage__quota">
      / {{ workspaceUsage.rows_quota }}</small
    >
    <Teleport to="body">
      <div
        v-if="tooltipPosition"
        class="tooltip tooltip--body tooltip--center saas-all-workspaces-row-usage__tooltip"
        :style="{
          top: `${tooltipPosition.top}px`,
          left: `${tooltipPosition.left}px`,
        }"
      >
        <div class="tooltip__content saas-dashboard__usage-tooltip-content">
          <WorkspaceUsageTooltipList
            :workspace-usage="workspaceUsage"
          ></WorkspaceUsageTooltipList>
        </div>
      </div>
    </Teleport>
  </span>
</template>

<script>
import WorkspaceUsageTooltipList from '@saas/components/dashboard/WorkspaceUsageTooltipList'

export default {
  name: 'AllWorkspacesWorkspaceRowUsage',
  components: { WorkspaceUsageTooltipList },
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    componentArguments: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tooltipPosition: null,
    }
  },
  computed: {
    // The usage isn't there while it's being fetched, or for a workspace that
    // was created after it was fetched.
    workspaceUsage() {
      return (this.componentArguments.usageData ?? []).find(
        (u) => u.workspace_id === this.workspace.id
      )
    },
    overLimit() {
      return this.workspaceUsage.row_count > this.workspaceUsage.rows_quota
    },
  },
  beforeUnmount() {
    this.hideTooltip()
  },
  methods: {
    showTooltip() {
      const rect = this.$refs.anchor.getBoundingClientRect()
      this.tooltipPosition = {
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + rect.width / 2 + window.scrollX,
      }
      // The page scrolls within its own container, which would move the text
      // away from the tooltip.
      window.addEventListener('scroll', this.hideTooltip, true)
    },
    hideTooltip() {
      this.tooltipPosition = null
      window.removeEventListener('scroll', this.hideTooltip, true)
    },
  },
}
</script>
